// src/constants/about/aboutConstants.js

export const ABOUT_STATS = [
  {
    label: "Dự án hoàn thành",
    value: "15+",
  },
  {
    label: "Khách hàng hài lòng",
    value: "200+",
  },
  {
    label: "Năm kinh nghiệm",
    value: "10",
  },
  {
    label: "Giải thưởng uy tín",
    value: "5",
  },
];

export const TESTIMONIALS = [
  {
    name: "Nguyễn Văn Khánh",
    content:
      "Mỹ Diệp đã giúp tôi tìm được căn hộ mơ ước với dịch vụ tận tâm và chuyên nghiệp.",
  },
  {
    name: "Nguyễn Thị Phương Thảo",
    content:
      "Quá trình tư vấn minh bạch, hỗ trợ tận tình và rất hiệu quả.",
  },
  {
    name: "Trần Quang Minh",
    content:
      "Tôi rất hài lòng với những cơ hội đầu tư mà Mỹ Diệp mang lại.",
  },
];

export const FOUNDER_INFO = {
  name: "Mỹ Diệp",
  position: "Founder & CEO",
  email: "mydiep@example.com",

  video:
    "/assets/DraftResource_1762505238.391840.MOV",

  description: `
Mỹ Diệp là người sáng lập và điều hành dự án với tầm nhìn chiến lược,
tận tâm xây dựng những khu nghỉ dưỡng và đô thị biển đẳng cấp,
mang lại giá trị bền vững cho cộng đồng và nhà đầu tư.

Với kinh nghiệm nhiều năm trong lĩnh vực bất động sản cao cấp,
cô luôn đặt chất lượng, uy tín và sự hài lòng của khách hàng lên hàng đầu.
`,

  quote:
    "Tầm nhìn của tôi là kết nối thiên nhiên – kiến trúc – cộng đồng, tạo ra không gian sống lý tưởng cho tất cả mọi người.",
};